import { useEffect } from 'react';

export const usePreventModalScroll = () => {
  useEffect(() => {
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.overflow = 'hidden';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    return () => {
      document.body.style.position = 'static';
      document.body.style.overflow = 'auto';
      window.scrollTo({ top: scrollY });
    };
  }, []);
  return;
};
